import React from 'react';
import './App.css';
import {Route} from 'react-router-dom'
import Plan from './Plan'
import Register from './Register'
import CreditCard from './CreditCard'
import Header from '../component/Header'
import Footer from '../component/Footer'
import ThankYou from '../component/ThankYou'
import {history} from '../store'

const App = () => (
    <div>
        {
            history.location.pathname === '/register' || history.location.pathname === '/plan' || history.location.pathname === '/'  ?
                <header className="header__inner"></header> : null
        }
        {
            history.location.pathname === '/register' || history.location.pathname === '/plan' || history.location.pathname === '/' ? <Header/> : null
        }
        <main>
            <Route exact path="/" component={Plan}/>
            <Route path="/plan" component={Plan}/>
            <Route path="/register" component={Register}/>
            <Route path="/creditcard" component={CreditCard}/>
            <Route path="/thanks" component={ThankYou}/>
        </main>
        {
            history.location.pathname === '/register' || history.location.pathname === '/plan' || history.location.pathname === '/'  ? <Footer/> : null
        }
    </div>
)


export default App;


// WEBPACK FOOTER //
// ./src/containers/App.js